import { Button, Col, Row } from "antd";
import { HTMLAttributes } from "react";
import { Titled } from "./Titled";
import _styles from "../Interactive.module.scss";
import classNames from "classnames/bind";
const styles = classNames.bind(_styles);

export const Buttons = ({
  items,
  mobile,
  title,
  className,
  ...rest
}: {
  title?: string;
  contrastGrayscale?: number;
  mobile?: boolean;
  items: { name: JSX.Element | string; onClick?: () => void }[];
} & HTMLAttributes<HTMLDivElement>) => (
  <Titled title={title} className={styles(className, "buttonsKeyboard")} {...rest}>
    <div style={{ paddingLeft: !mobile ? "40px" : "" }}>
      <Row gutter={[8, 8]} justify="end">
        {items.map(({ name, onClick }, i) => (
          <Col flex={0} key={i}>
            <Button className={styles("button")} onClick={onClick}>
              {name}
            </Button>
          </Col>
        ))}
      </Row>
    </div>
  </Titled>
);
